<template>
  <FormItemWrapper
    :minimal="true"
    size="sm"
  >
    <el-select
      v-model="sort"
      :placeholder="$t('formItemSortByPlaceholder')"
    >
      <el-option
        v-for="item in sortOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { Select, Option } from 'element-ui';
import FormItemWrapper from '@/components/formItem/Wrapper.vue';

Vue.use(Select);
Vue.use(Option);

export default {
  name: 'SortBy',
  components: {
    FormItemWrapper,
  },
  data() {
    return {
      sortValue: '',
    };
  },
  computed: {
    sortOptions() {
      return [
        {
          label: this.$t('formItemSortByTextValueDefault'),
          value: 0,
        },
        {
          label: this.$t('formItemSortByTextValueLowToHigh'),
          value: 1,
        },
        {
          label: this.$t('formItemSortByTextValueHighToLow'),
          value: 2,
        },
      ];
    },
    sort: {
      get() {
        return this.$store.state.sort.activeSorts.sort;
      },
      set(value) {
        this.$store.commit('sort/SET_SORT', value);
      },
    },
  },
};
</script>
